module.exports = __webpack_public_path__ + "img/group-people-white.6058ed55.svg";